import { Group } from '@mantine/core';
import {
  IconCalendarEvent,
  IconDotsCircleHorizontal,
  IconFiles,
  IconLayoutSidebarRightCollapse,
  IconX,
} from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useNavigationItem } from '../../../Organismns/Navigation/NavigationItemHook';
import { useBookitupScope } from '../../../Service/Context/BookitupSubscriptionContext';
import { EventParticipationsContext } from '../../../Service/Context/EventParticipationContextV2';
import ActionIconWithText from './ActionIconWithText';
import InboxIconWithIndicator from './InboxIconWithIndicator';

interface HandlersProps {
  openNavBar: () => void;
  toggleAsideBar: () => void;
  asideBarOpen: boolean;
}

const EventDetailsFooter: FC<HandlersProps> = ({ openNavBar, toggleAsideBar, asideBarOpen }) => {
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { unreadMessagesProps } = useContext(EventParticipationsContext);
  const { unreadCount } = unreadMessagesProps;
  const { isScopeSelected: hasDocumentsScope } = useBookitupScope('DOCUMENTS');
  const { isScopeSelected: hasEmailScope } = useBookitupScope('EMAILS');
  const detailsActive = useNavigationItem(`/events/${eventId}/details`);
  const documentsActive = useNavigationItem(`/events/${eventId}/documents`);
  const emailsActive = useNavigationItem(`/events/${eventId}/emails`);
  const { isScopeSelected: hasContractsScope } = useBookitupScope('CONTRACTS');
  const { isScopeSelected: hasQuestionnairesScope } = useBookitupScope('QUESTIONNAIRES');

  const hasAnyDocumentScope = hasDocumentsScope || hasContractsScope || hasQuestionnairesScope;

  // eslint-disable-next-line no-underscore-dangle
  const _navigate = (pathname: string) => {
    if (asideBarOpen) {
      toggleAsideBar();
    }
    navigate(pathname);
  };

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText label="Alle" onClick={openNavBar}>
        <IconLayoutSidebarRightCollapse />
      </ActionIconWithText>
      <ActionIconWithText
        label="Details"
        active={detailsActive}
        onClick={() => _navigate(`/events/${eventId}/details`)}
      >
        <IconCalendarEvent />
      </ActionIconWithText>
      {hasAnyDocumentScope && (
        <ActionIconWithText
          label="Dateien"
          active={documentsActive}
          onClick={() => _navigate(`/events/${eventId}/documents`)}
        >
          <IconFiles />
        </ActionIconWithText>
      )}
      {hasEmailScope && (
        <ActionIconWithText
          label="Mails"
          active={emailsActive}
          onClick={() => _navigate(`/events/${eventId}/emails/inbox`)}
        >
          <InboxIconWithIndicator unreadCount={unreadCount} />
        </ActionIconWithText>
      )}
      <ActionIconWithText label={asideBarOpen ? '' : 'Mehr'} onClick={toggleAsideBar}>
        {asideBarOpen ? <IconX /> : <IconDotsCircleHorizontal />}
      </ActionIconWithText>
    </Group>
  );
};

export default EventDetailsFooter;
